import { EntityId } from '@reduxjs/toolkit';
import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { API_V2_BASE_PATH } from '../constants';
import {
  RefereesListDTO,
  ReferralProgramDTO,
  ReferralProgramPayload,
  ReferralStatsDTO,
  ReferralTiersPayload,
  ReferralValidationDTO,
  ReferrersListDTO,
} from '../types';

export const referralApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 20000 });

const BASE_PATH = API_V2_BASE_PATH;

export const getReferralProgramApi = async (franchiseId: EntityId) => {
  const response = await referralApi.api.get<ReferralProgramDTO>(
    `${BASE_PATH}/franchises/${franchiseId}/referral-program`,
  );
  return response.data;
};

export const upsertReferralProgramApi = async (franchiseId: EntityId, payload: ReferralProgramPayload) => {
  const response = await referralApi.api.put<ReferralProgramDTO>(
    `${BASE_PATH}/franchises/${franchiseId}/referral-program`,
    payload,
    {},
  );
  return response.data;
};

export const upsertReferralTiersApi = async (franchiseId: EntityId, payload: ReferralTiersPayload) => {
  const response = await referralApi.api.put<ReferralProgramDTO>(
    `${BASE_PATH}/franchises/${franchiseId}/referral-program/tiers`,
    payload,
    {},
  );
  return response.data;
};

export const fetchReferralStatsApi = async (franchiseId: EntityId) => {
  const response = await referralApi.api.get<ReferralStatsDTO>(`${BASE_PATH}/franchises/${franchiseId}/referral-stats`);
  return response.data;
};

export const fetchReferrersApi = async (franchiseId: EntityId, skip: number, limit: number) => {
  const response = await referralApi.api.get<ReferrersListDTO>(`${BASE_PATH}/franchises/${franchiseId}/referrers`, {
    params: { skip, limit },
  });
  return response.data;
};

export const fetchRefereesApi = async (franchiseId: EntityId, referrerId: string) => {
  const response = await referralApi.api.get<RefereesListDTO>(
    `${BASE_PATH}/franchises/${franchiseId}/referrers/${referrerId}/referees`,
  );
  return response.data;
};

export const validateReferralApi = async (franchiseId: EntityId, referralId: string) => {
  const response = await referralApi.api.post<ReferralValidationDTO>(
    `${BASE_PATH}/franchises/${franchiseId}/referrals/${referralId}/validate`,
    {},
    {},
  );
  return response.data;
};
